import { SEARCH_AUTOCOMPLETE_LIST_LOADING, SEARCH_COMPONENT_RESET, SEARCH_FINAL_QUERY, SEARCH_QUERY_LOADING, SET_AUTOCOMPLETE_VISIBILITY } from "../actions/action_types";

export default function searchReducer(state = { fullList: [], displayList: [], finalSearch: [], autocompleteVisible: false }, action) {
    switch (action.type) {
        case SEARCH_AUTOCOMPLETE_LIST_LOADING:
            return { fullList: action.payload, displayList: action.payload }
        case SEARCH_QUERY_LOADING:
            let filteredList = state.fullList.filter(item => item.toLowerCase().indexOf(action.payload.toLowerCase()) === 0)
            return {...state, displayList: filteredList }
        case SEARCH_FINAL_QUERY:
            let finalSearchResultList = state.fullList.filter(item => item.toLowerCase().indexOf(action.payload.toLowerCase()) === 0)
            return {...state, finalSearch: finalSearchResultList }
        case SEARCH_COMPONENT_RESET:
            return { fullList: [], displayList: [], finalSearch: [], autocompleteVisible: false }
        case SET_AUTOCOMPLETE_VISIBILITY:
            return {...state, autocompleteVisible: action.payload }
        default:
            return state
    }
}